import * as React from 'react';
import styles from './GeofenceMapWrapper.module.css';

interface GeofenceMapWrapperProps {
  children: React.ReactNode;
}

const GeofenceMapWrapper: React.FC<GeofenceMapWrapperProps> = ({
  children,
}) => {
  return <div className={styles.GeofenceMapWrapper}>{children}</div>;
};

export default GeofenceMapWrapper;
